import x from './Sidebar'

export default x
